import React from "react";
import styled from "@emotion/styled";
import styleVariables from "../../helpers/styleVariables";
import { useTranslation } from "next-i18next";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { getScrollbarWidth } from "../../helpers/utils";

const Root = styled.div`
  background: ${styleVariables.colors.beige};
`;

const CustomLabel = styled.div`
  font-size: 14px;
  margin-bottom: 6px;
  color: ${styleVariables.colors.grey};
`;

interface SelectProps {
  options: Array<{ name: string; id: string | number }>;
  value?: string;
  handleChange: (input: string) => void;
  label: string;
  displayEmpty?: boolean;
}

const SelectComponent: React.FC<SelectProps> = ({
  options,
  value,
  handleChange,
  label,
  displayEmpty,
}) => {
  if (!options) {
    return null;
  }
  const { t } = useTranslation();

  if (displayEmpty && !options.find(({ id }) => id === "")) {
    options.unshift({
      id: "",
      name: t("all"),
    });
  }
  const defaultValue = options.find(({ id }) => id === value)
    ? value?.toString()
    : options[0].id.toString();

  const headerElement = document.getElementById("js-header");

  const onOpen = () => {
    if (headerElement) {
      headerElement.style.right = `${getScrollbarWidth()}px`;
    }
  };

  const onClose = () => {
    if (headerElement) {
      headerElement.style.right = "";
    }
  };

  return (
    <>
      <CustomLabel>{label}</CustomLabel>
      <FormControl fullWidth variant="standard">
        <Select
          value={defaultValue}
          displayEmpty={displayEmpty}
          onChange={(e: SelectChangeEvent) => handleChange(e.target.value)}
          onOpen={onOpen}
          onClose={onClose}
        >
          {options.map(({ id, name }) => (
            <MenuItem value={id} key={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default SelectComponent;
